import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import debug from "debug";
var logRedirect = debug("IF:REDIRECT");
var Redirects = function Redirects(redirectRules) {
    "use strict";
    var _this = this;
    _class_call_check(this, Redirects);
    this.redirectRules = redirectRules;
    this.checkLocation = function(location) {
        var redirectTarget = _this.find(location);
        if (redirectTarget && _this.history) {
            logRedirect("From ".concat(location.pathname, " to ").concat(redirectTarget));
            _this.history.replace(redirectTarget);
        }
    };
    this.listen = function(history) {
        logRedirect("Listening");
        _this.history = history;
        _this.checkLocation(_this.history.location);
        _this.history.listen(_this.checkLocation);
    };
    this.find = function(location) {
        var pathname = decodeURIComponent(location.pathname);
        var query = decodeURIComponent(location.search);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _this.redirectRules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var rule = _step.value;
                var resolvedPath = rule(pathname, query);
                if (resolvedPath !== null) {
                    return resolvedPath;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return null;
    };
};
export { Redirects as default };
